/**
 * Translation helper for campaign content components.
 * Uses the global i18n object provided by Rails.
 */
export function t(key: string, options?: Record<string, unknown>): string {
  return window.i18n.t(key, options)
}
